<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Warehouse"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <v-autocomplete
                        label="Product"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="id"
                        :error-messages="product_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="category_id.value.value"
                        :items="getCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="category_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <v-autocomplete
                        label="Brand"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="brand_id.value.value"
                        :items="getBrandList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="brand_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Sub Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="subcategory_id.value.value"
                        :items="getSubCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="subcategory_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                        class="py-1"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <v-btn
                        class="bg-brand my-1"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Product Type"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_type_id.value.value"
                        :items="getProductTypeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="product_type_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Stock Reports With Values
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col
                    md="4"
                    cols="12"
                    class="d-flex align-center flex-column"
                  >
                  </v-col>

                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reports?.data"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.purchase_unit_price="{ item }">
                    {{ item?.purchase_unit_price?.toFixed(2) }}
                  </template>

                  <template v-slot:item.sales_unit_price="{ item }">
                    {{ item?.sales_unit_price?.toFixed(2) }}
                  </template>

                  <template v-slot:item.quantity="{ item }">
                    {{ item?.quantity?.toFixed(2) }}
                  </template>

                  <template v-slot:item.valuation="{ item }">
                    {{ item?.valuation?.toFixed(2) }}
                  </template>

                  <template v-slot:tfoot="{ items }">
                    <tfoot>
                      <tr style="font-weight: bold;">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-end px-1">Total</td>
                        <td class="text-end px-1"></td>
                        <td class="text-end px-1"></td>
                        <td class="text-end px-1">{{ reports?.total_quantity }}</td>
                        <td class="text-end px-1">{{ reports?.total_valuation }}</td>
                        
                      </tr>
                    </tfoot>
                  </template>
                </v-data-table>
                
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", sortable: false,},
      { title: "Warehouse", key: "warehouse_name", align: "left", sortable: false },
      { title: "Product Code", key: "product_code", align: "left", sortable: false },
      { title: "Product Name", key: "product_name", align: "left", sortable: false },
      { title: "Batch", key: "batch_no", align: "left", sortable: false },
      { title: "Pur. Price", key: "purchase_unit_price", align: "end", sortable: false },
      { title: "Sales Price", key: "sales_unit_price", align: "end", sortable: false },
      { title: "Quantity", key: "quantity", align: "end", sortable: false },   
      { title: "Valuation", key: "valuation", align: "end", sortable: false },     
    ],
  }),
  watch: {},
  created() {

    const promises = [];

    // if (this.$store.getters.getProductTypeList.length == 0) {
      promises.push(this.$store.dispatch("getProductTypeList"));
    // }
    // if (this.$store.getters.getCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getCategoryList"));
    // }
    // if (this.$store.getters.getSubCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getSubCategoryList"));
    // }
    // if (this.$store.getters.getBrandList.length == 0) {
      promises.push(this.$store.dispatch("getBrandList"));
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getSupplierMapList;
    },
    getProductTypeList() {
      let data = this.$store.getters.getProductTypeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getCategoryList() {
      let data = this.$store.getters.getCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    
    getSubCategoryList() {
      let data = this.$store.getters.getSubCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getBrandList() {
      let data = this.$store.getters.getBrandList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },

    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) =>
          item.branch_id == this.$store.getters.getAuthUser.branch_id &&
          item.status == 1
      );
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
        // product_type_id: yup.number().positive().integer().nullable().label('Product Type'),
        // category_id: yup.number().positive().integer().nullable().label('Category'),
        // subcategory_id: yup.number().positive().integer().nullable().label('Sub Category'),
      }),
    });

    const product_type_id = useField("product_type_id");
    const product_id= useField("product_id");
    const warehouse_id= useField("warehouse_id");
    const category_id = useField("category_id");
    const subcategory_id = useField("subcategory_id");
    const brand_id = useField("brand_id");
    const with_values = useField("with_values");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const reports = ref([]);

    const submit = handleSubmit((values) => {
      loading.value = true;
      values.with_values = true;

      Axios.get(`${prefix}inventory/stock-report`, { params: values })
        .then((response) => {
          reports.value = response.data;
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      product_type_id,
      product_id,
      warehouse_id,
      category_id,
      subcategory_id,
      brand_id,
      submit,
      errorMessages,
      with_values,
      loading,
      reports,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingProduct", item);
      this.$router.push({ name: "add-product", query: {id: item.id} });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Warehouse",
        "Product Code",
        "Product Name",
        "Batch",
        "Unit Price",
        "Quantity",
        "Valuation",
      ];
      const rows = (this.reports || []).map((item) => [
        serialNumber++,
        item.warehouse_name,
        item.product_code,
        item.product_name,
        item.batch_no,
        item.purchase_unit_price,
        item.quantity,
        item.valuation,
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Stock Report",
        "stock_report_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [[
        "#SL",
        "Warehouse",
        "Product Code",
        "Product Name",
        "Batch",
        "Unit Price",
        "Quantity",
        "Valuation",
      ]];
      var serialNumber = 1;
      (this.reports || []).forEach((item) => {
        data.push([
          serialNumber++,
          item.warehouse_name,
          item.product_code,
          item.product_name,
          item.batch_no,
          item.purchase_unit_price,
          item.quantity,
          item.valuation,
        ]);
      });
      this.$exportTableToExcel(data, "stock_report_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[
        "#SL",
        "Warehouse",
        "Product Code",
        "Product Name",
        "Batch",
        "Unit Price",
        "Quantity",
        "Valuation",
      ]];
      var serialNumber = 1;
      (this.reports || []).forEach((item) => {
        data.push([
          serialNumber++,
          item.warehouse_name,
          item.product_code,
          item.product_name,
          item.batch_no,
          item.purchase_unit_price,
          item.quantity,
          item.valuation,
        ]);
      });

      this.$exportTableToCSV(data, "stock_report_" + this.$fileDate());
    },
  },
  mounted() { 
    // Auto-trigger search on mount like the requisition list
    // this.$nextTick(() => {
    //   this.$refs.searchButton.$el.click();
    // });   
  },
};
</script>
